import DocumentProfile from 'lib/common/GeneralComponents/DocumentProfile';
import React, { createContext, ReactNode, useState } from 'react';

interface DocumentProfileContextValue {
  onOpenDocumentProfile: (id: string) => void;
}

export const DocumentProfileContext =
  createContext<DocumentProfileContextValue>({
    onOpenDocumentProfile: () => {},
  });

interface DocumentProfileProviderProps {
  children: ReactNode;
}

export const DocumentProfileProvider: React.FC<
  DocumentProfileProviderProps
> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<string>();

  function onOpenDocumentProfile(id: string) {
    setSelectedDocumentId(id);
    setOpen(true);
  }

  function handleClose() {
    setSelectedDocumentId(undefined);
    setOpen(false);
  }

  return (
    <DocumentProfileContext.Provider
      value={{
        onOpenDocumentProfile,
      }}
    >
      {children}
      <DocumentProfile
        documentId={selectedDocumentId}
        open={open}
        handleClose={handleClose}
      />
    </DocumentProfileContext.Provider>
  );
};
